import { Divider, Menu } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { Fragment, useContext } from "react";
import AppContext from "../../../data/AppContext";
import StyledMenuItem from "../StyledMenuItem";
import { isAuthorizedForMenuItem } from "./popupMenuUtilities";


/**
 * This is a generic popup menu component with sections of menu items.
 * See ItemCardMenu for a domain specific implementation of this component.
 *
 * prop: menuItemSections - This component takes an array of sections of menu items that are mapped over and rendered, each
 * 		 separated with a divider. Each section is an array of individual menu items that can contain a label, target and icon
 * prop: buttonStyles - styles can be passed in to render the button in a certain position on the page
 * prop: show - the component that will show the popup when it is hovered (if none is passed button always shows)
 */
export default function SectionedPopupMenu(props) {
	const { menuItemSections, triggerButton, handleClose, anchorEl } = props;
	const appContext = useContext(AppContext);
	const open = Boolean(anchorEl);

	const renderMenuItems = menuItems => {
		return menuItems.map(menuItem => {
			let doRenderMenuItem = isAuthorizedForMenuItem(menuItem, appContext);
			return doRenderMenuItem && (
				<StyledMenuItem
					key={menuItem.label}
					label={menuItem.label}
					target={menuItem.target}
					action={menuItem.action}
					icon={menuItem.icon}
					destructive={menuItem.destructive}
					noNewTab={menuItem.noNewTab}
					handleClose={handleClose}
				/>
			)
		});
	};

	const renderDivider = index => {
		return !(index == menuItemSections.length - 1) && <Divider />;
	};

	return (
		<Fragment>
			{triggerButton()}
			{open ?
				<Menu
					anchorEl={anchorEl}
					keepMounted
					open
					onClose={() => handleClose("Menu Closed")}
				>
					{menuItemSections.map((menuItems, index) => (
						<div key={index}>
							{renderMenuItems(menuItems)}
							{renderDivider(index)}
						</div>
					))}
				</Menu>
				: null
			}
		</Fragment>
	);
}

SectionedPopupMenu.propTypes = {
	menuItemSections: PropTypes.array.isRequired,
	triggerButton: PropTypes.func.isRequired,
	handleClose: PropTypes.func.isRequired,
	anchorEl: PropTypes.object
};
